import React from 'react'
import './StepProgressBar.scss'
import Step from './Step/Step'

/**
 * StepProgressBar component renders a progress bar with multiple steps.
 * Each step is represented by the `Step` component and visually indicates the progress of an application.
 *
 * @component
 * @memberof Components 
 * @param {Object} props - The component props.
 * @param {Array} props.array - An array of step objects, each containing `title1` and `title2`.
 * @param {number} props.applicationProgressId - The current progress ID indicating the completed step.
 * @param {number} props.objection - The objection status (1 for an objection, 0 otherwise).
 * @param {Function} props.openDetailsPopUp - Function to open a popup with step details.
 * @param {string} props.pageName - The name of the current page, used for styling.
 *
 * @example
 * const steps = [
 *   { title1: "Step 1", title2: "Description 1" },
 *   { title1: "Step 2", title2: "Description 2" }
 * ];
 * <StepProgressBar 
 *   array={steps} 
 *   applicationProgressId={1} 
 *   objection={0} 
 *   openDetailsPopUp={(value) => console.log(value)} 
 *   pageName="New Connection" 
 * />
 *
 * @returns {JSX.Element} The StepProgressBar component containing multiple steps.
 */

const StepProgressBar = (props) => {
  const {
    array,
    applicationProgressId,
    objection,
    skippedSteps = [], // 👈 NEW
    openDetailsPopUp,
    pageName,
  } = props;

  const openSubPopUp = (value, status) => {
    if (status) {
      openDetailsPopUp(value);
    }
  };

  return (
    <div className="container">
      <div className="arrow-steps clearfix">
        {array.map((item, index) => {
          let status = "";

          if (skippedSteps.includes(index)) {
  status = "skipped";
}
else if (index < applicationProgressId) {
  status = "done";
}
else if (index === applicationProgressId && objection === 1) {
  status = "current objection";
}
else if (index === applicationProgressId && index === array.length - 1) {
  // Last step (Completed) - show as done with green tick
  status = "done";
}
else if (index === applicationProgressId) {
  status = "current";
}


          return (
            <Step
              key={index}
              number={index + 1}
              title1={item.title1}
              title2={item.title2}
              status={status}
              openSubPopUp={openSubPopUp}
              pageName={pageName}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StepProgressBar;
